﻿export const isNumeric = (value: any) => {
    return !isNaN(parseFloat(value)) && isFinite(value)
}
